import { Settlement } from '../../../models/Entities/Settlements/Settlement';

export interface CurrencyTotal {
  currency: string;
  amount: number;
}

/**
 * Total de un grupo de liquidaciones, separado por moneda: nunca se suman
 * montos de monedas distintas. Usa el mismo importe que muestra cada tarjeta
 * (`ownerAmountWithholdingTotal`), así el total del mes cierra con la lista.
 * Una liquidación sin moneda en el total toma la de la liquidación.
 */
export const totalsByCurrency = (items: Settlement[]): CurrencyTotal[] => {
  const sums = new Map<string, number>();
  (items ?? []).forEach((item) => {
    (item.totals ?? []).forEach((total) => {
      const currency = (total.currencyCode || item.currencyCode || '').toUpperCase();
      sums.set(currency, (sums.get(currency) ?? 0) + (total.ownerAmountWithholdingTotal ?? 0));
    });
  });
  return Array.from(sums.entries())
    .filter(([, amount]) => amount !== 0)
    .map(([currency, amount]) => ({ currency, amount }))
    .sort((a, b) => a.currency.localeCompare(b.currency));
};
